import request from "@/utils/request";
const BASE_API = process.env.VUE_APP_BASE_API;

// build

export function getPhone(param) {
    return request({
        url: `${BASE_API}/api/phone/setting`,
        method: "get",
        params: param,
    });
}